import fetch from '../../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    observation: null,
    observationRecords: null,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  observation(state) {
    return state.observation
  },
  error(state) {
    return state.error
  },
}

const actions = {
  /**
   * @param commit
   * @param dispatch
   * @param rootState
   * @param data
   * @returns {Promise<T | never> | * | *}
   */
  get({commit, dispatch, rootState}, data) {
    commit(types.SET_VIEW_OBSERVATION_LOADING);
    return fetch('/observations/' + data.id, {
      method: 'GET',
    })
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_VIEW_OBSERVATION, data)
        return data
      })
      .catch((error) => {
        commit(types.SET_VIEW_OBSERVATION_ERROR, error.message)
        console.log(error)
      })
  },
  update({commit, dispatch, rootState}, data) {
    commit(types.SET_VIEW_OBSERVATION_LOADING)
    return fetch('/observations/' + data.id, {
      method: 'PUT',
      body: JSON.stringify(data.observation)
    })
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_VIEW_OBSERVATION, data)
      })
      .catch((error) => {
        commit(types.SET_VIEW_OBSERVATION_ERROR, error)
      })
  },
  getRecords({commit, state}) {
    commit(types.SET_VIEW_OBSERVATION_LOADING)
    return fetch('/observations/' + state.observation.id + '/observation_records?page=1&itemsPerPage=500', {
      method: 'GET',
    })
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_VIEW_OBSERVATION_RECORDS, data['hydra:member'])
      })
      .catch((error) => {
        commit(types.SET_VIEW_OBSERVATION_ERROR, error)
      })
  },
  reset({commit, state}) {
    commit(types.SET_VIEW_OBSERVATION_LOADING);
    commit(types.RESET)
  },
}

const types = {
  SET_VIEW_OBSERVATION_LOADING: 'SET_VIEW_OBSERVATION_LOADING',
  SET_VIEW_OBSERVATION: 'SET_VIEW_OBSERVATION',
  SET_VIEW_OBSERVATION_RECORDS: 'SET_VIEW_OBSERVATION_RECORDS',
  SET_VIEW_OBSERVATION_ERROR: 'SET_VIEW_OBSERVATION_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_VIEW_OBSERVATION_LOADING](state) {
    state.isLoading = true;
    state.error = null;
  },
  [types.SET_VIEW_OBSERVATION](state, data) {
    state.observation = data
    state.isLoading = false
    state.error = null;
  },
  [types.SET_VIEW_OBSERVATION_RECORDS](state, data) {
    state.observationRecords = data
    state.observation.records = state.observationRecords
    state.isLoading = false
  },
  [types.SET_VIEW_OBSERVATION_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET_ERROR](state) {
    state.isLoading = false;
    state.error = null;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
